/**
 * /tenant-records/$slug/enrollment-issuers — trusted enrollment issuers for one
 * tenant. A platform control, so it lives on the tenant record rather than in
 * the tenant console and needs no tenant grant. Intentionally has no tab or menu
 * entry: operators open it by URL. The parent tenant-record route already
 * requires a platform admin with tenants.read. Thin route shim; domain logic
 * lives in features/trusted-enrollment-issuers/.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchTrustedEnrollmentIssuers } from "@/features/trusted-enrollment-issuers/queries";
import { TrustedEnrollmentIssuersPage } from "@/features/trusted-enrollment-issuers/pages/trusted-enrollment-issuers-page";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute("/_authed/tenant-records/$slug/enrollment-issuers")({
  loader: async ({ context }) => {
    // A prefetch failure renders in the page's own error state, not the route boundary.
    await context.queryClient.ensureQueryData({
      queryKey: queryKeys.trustedEnrollmentIssuers.list(context.record.id),
      queryFn: () => fetchTrustedEnrollmentIssuers(context.record.id),
    }).catch(() => undefined);
    return null;
  },
  component: TrustedEnrollmentIssuersPage,
});
